/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminAnalyticsOverviewDto
 */
export interface AdminAnalyticsOverviewDto {
    /**
     * Total number of registered users
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    totalUsers: number;
    /**
     * Number of Premium subscribers
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    premiumUsers: number;
    /**
     * Number of Premium Plus subscribers
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    premiumPlusUsers: number;
    /**
     * Number of users active in last 7 days
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    activeUsers7d: number;
    /**
     * Number of users active in last 30 days
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    activeUsers30d: number;
    /**
     * Number of users active in last 90 days
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    activeUsers90d: number;
    /**
     * Number of inactive free users (no login for 12+ months)
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    inactiveFreeUsers: number;
    /**
     * Number of inactive paid users (no login for 12+ months)
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    inactivePaidUsers: number;
    /**
     * Total number of portfolios
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    totalPortfolios: number;
    /**
     * Total number of trades
     * @type {number}
     * @memberof AdminAnalyticsOverviewDto
     */
    totalTrades: number;
}

export function AdminAnalyticsOverviewDtoFromJSON(json: any): AdminAnalyticsOverviewDto {
    return AdminAnalyticsOverviewDtoFromJSONTyped(json, false);
}

export function AdminAnalyticsOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAnalyticsOverviewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalUsers': json['totalUsers'],
        'premiumUsers': json['premiumUsers'],
        'premiumPlusUsers': json['premiumPlusUsers'],
        'activeUsers7d': json['activeUsers7d'],
        'activeUsers30d': json['activeUsers30d'],
        'activeUsers90d': json['activeUsers90d'],
        'inactiveFreeUsers': json['inactiveFreeUsers'],
        'inactivePaidUsers': json['inactivePaidUsers'],
        'totalPortfolios': json['totalPortfolios'],
        'totalTrades': json['totalTrades'],
    };
}

export function AdminAnalyticsOverviewDtoToJSON(value?: AdminAnalyticsOverviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalUsers': value.totalUsers,
        'premiumUsers': value.premiumUsers,
        'premiumPlusUsers': value.premiumPlusUsers,
        'activeUsers7d': value.activeUsers7d,
        'activeUsers30d': value.activeUsers30d,
        'activeUsers90d': value.activeUsers90d,
        'inactiveFreeUsers': value.inactiveFreeUsers,
        'inactivePaidUsers': value.inactivePaidUsers,
        'totalPortfolios': value.totalPortfolios,
        'totalTrades': value.totalTrades,
    };
}

